import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

// Feature-scoped API module for storefront contact messages.
// Convention, matching vehicleApi.js: reads return data or a safe default and
// toast on error; mutations return the record or null and let the caller toast success.

const read = async (url, params, fallback, label) => {
  try {
    const res = await axiosInstance.get(url, { params });
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error loading ${label}`);
    return fallback;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error loading ${label}`);
    return fallback;
  }
};

const mutate = async (method, url, payload, label) => {
  try {
    const res = await axiosInstance[method](url, payload);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error ${label}`);
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error ${label}`);
    return null;
  }
};

export const getContactMessages = (params) =>
  read("/api/contact/admin-list", params, { messages: [], total: 0, page: 1, totalPages: 1 }, "contact messages");

export const markContactMessageRead = (id) =>
  mutate("put", `/api/contact/${id}/read`, undefined, "marking message as read");
